import { DialogActions } from '@mui/material';
import { getActiveMoneyReports } from 'lib/api/reports';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { errorHandler } from 'lib/functions/errors';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const ActiveDocuments = (props: any) => {
  const { businessIdentifier, setOpenShoppingCart, request, notDialog } = props;
  const [loading, setLoading] = useState(false);
  const [documentsSuggested, setDocumentsSuggested] = useState<any[]>([]);
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });
  const dispatch = useDispatch();

  const setUp = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    if (!businessIdentifier) return;
    setLoading(true);
    try {
      let queryParams = `page=${page}&pageSize=${pageSize}&requestType=${request.productType}&dataType=active`;
      if (request.productType === 'credit') {
        queryParams += `&stakeholderIdentifier=${businessIdentifier}`;
      } else {
        queryParams += `&businessIdentifier=${businessIdentifier}`;
      }
      const response = await getActiveMoneyReports(dispatch, queryParams);
      setDocumentsSuggested(response.data);
      setPagination(response.pagination);
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void setUp({ page: 1, pageSize: PAGE_SIZE });
  }, []);

  if (loading && !businessIdentifier)
    return <CenteredCircularProgress type="layout" />;
  if (loading && businessIdentifier)
    return <CenteredCircularProgress relative />;

  return (
    <div>
      <div>
        <HeaderWithActions
          title={`Documentos ${request.productType === 'credit' ? 'Créditos' : request.productType === 'factoring' ? 'Factoring' : ''}`}
          variant={'body1'}
          buttons={[]}
        />
        <TableWithPagination
          dataHeaders={[
            { key: 'exception', label: 'Exc', type: 'boolean-exception-null' },
            { key: 'documentNumber', label: 'Folio' },
            { key: 'documentType', label: 'Fuente' },
            { key: 'stakeholderName', label: 'Deudor' },
            { key: 'operationId', label: 'Solicitud', type: 'numeric-id' },
            { key: 'amount', label: 'Monto', type: 'money' },
            { key: 'arrearAmount', label: 'En mora', type: 'money' },
            { key: 'amountConciliated', label: 'Conciliado', type: 'money' },
            { key: 'totalRemaining', label: 'Pendiente', type: 'money' },
          ]}
          finalSumRow
          pagination={pagination}
          setPagination={setPagination}
          setData={setDocumentsSuggested}
          data={documentsSuggested}
          searchData={setUp}
        />
      </div>
      {!notDialog && (
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingCart(false)}
            variant="outlined"
            color="secondary"
          >
            Cerrar
          </CustomButton>
        </DialogActions>
      )}
    </div>
  );
};

export default ActiveDocuments;
